import type { TypedResult } from '../utils/TypedResult.js';

/**
 * WebVTT transform stream style result.
 *
 * @group WebVTT
 *
 * @beta
 */
export type WebVttStyleResult = TypedResult<'style', string>;
